<template lang="pug">
system-tabs(section="/system/tickets")
    template(slot="tabbar-buttons")
        //- Convention, left to right: the destructive action, the way out, the
        //- primary action last - the same order the ticket detail's tab bar
        //- carries (spam, delete, dismiss, save-and-close, save).
        el-button.delete-button(
            v-if="saveState.id && !saveState.loadError"
            circle
            type="danger"
            icon="el-icon-fa-trash-alt far"
            :title="$t('Delete project')"
            :loading="saveState.deleting"
            @click="callDetail('confirmDelete')"
        )
        el-button(
            v-if="!saveState.loadError"
            circle
            icon="el-icon-fa-times fas"
            @click="callDetail('dismiss')"
        )
        el-button(
            v-if="!saveState.loadError"
            circle
            type="primary"
            icon="el-icon-fa-pen fas"
            @click="callDetail('edit')"
        )
    el-card(shadow="always")
        project-detail(ref="detail" scope="system" @state="saveState = $event")
    .buttons-flex(v-if="!saveState.loadError")
        .form-buttons
        .form-buttons
            el-button(round icon="el-icon-fa-times fas" @click="callDetail('dismiss')") {{ $t('Dismiss') }}
            el-button(round type="primary" icon="el-icon-fa-pen fas" @click="callDetail('edit')") {{ $t('Edit') }}
</template>

<i18n>
{
    "de": {
        "Dismiss": "Verwerfen",
        "Delete project": "Projekt löschen",
        "Edit": "Bearbeiten"
    }
}
</i18n>

<script>
import SystemTabs from '@/views/system/Partials/Tabs';
import ProjectDetail from '@/extensions/tickets/views/Projects/ProjectDetail';

// Pure chrome. Everything it triggers lives on ProjectDetail and is reached
// through callDetail() - one copy, shared with the CMS wrapper.
export default {
    name: 'SystemProjectDetail',
    components: { SystemTabs, 'project-detail': ProjectDetail },
    data() {
        return {
            saveState: {},
        };
    },
    methods: {
        callDetail(method, ...args) {
            const detail = this.$refs.detail;
            if (detail) detail[method](...args);
        },
    },
};
</script>
